<template>
    <div class="modal-content modal--happy">
        <div class="modal-header border-0 text-ceter">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">Harmonogram Happy Hours</h2>
            </div>
        </div>
        <div class="modal-body p-4 text-primary">
            <div class="tr-data mb-4 is-column">
                <div class="tr-data__cell" v-for="(happyHour, idx) in happyHours" :key="idx">
                    <div class="tr-data__dt">{{ happyHour.day }}</div>
                    <div v-if="happyHour.start || happyHour.finish" class="tr-data__dd">
                        od
                        <strong>{{ happyHour.start ? happyHour.start : '---' }}</strong> do
                        <strong>{{ happyHour.finish ? happyHour.finish : '---' }}</strong>
                    </div>
                    <div v-else class="tr-data__dd">
                        n/d
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button
                    class="btn btn-outline-secondary"
                    @click="closeModal"
                    data-dismiss="modal"
                >Zamknij</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        promotion() {
            return this.$store.getters.getPromotion
        },
        happyHours() {
            return [
                {
                    day: 'Poniedziałek',
                    start: this.promotion.monday_start_at,
                    finish: this.promotion.monday_finish_at
                },
                {
                    day: 'Wtorek',
                    start: this.promotion.tuesday_start_at,
                    finish: this.promotion.tuesday_finish_at
                },
                {
                    day: 'Środa',
                    start: this.promotion.wednesday_start_at,
                    finish: this.promotion.wednesday_finish_at
                },
                {
                    day: 'Czwartek',
                    start: this.promotion.thursday_start_at,
                    finish: this.promotion.thursday_finish_at
                },
                {
                    day: 'Piątek',
                    start: this.promotion.friday_start_at,
                    finish: this.promotion.friday_finish_at
                },
                {
                    day: 'Sobota',
                    start: this.promotion.saturday_start_at,
                    finish: this.promotion.saturday_finish_at
                },
                {
                    day: 'Niedziela',
                    start: this.promotion.sunday_start_at,
                    finish: this.promotion.sunday_finish_at
                }
            ]
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>